import { selectProfile, selectRequestingChangePlan } from '../../../../../store/workspace/selectors';
import { requestChangePlanThunk } from '../../../../../store/workspace/thunks';
import { setChangePlanModal } from '../../../../../store/workspace/slice';
import { purchasePlanDialogue } from '../../../../../configs/payment';
import { useDispatch, useSelector } from '../../../../../store/store';
import TextArea from '../../../../../components/TextArea';
import { LayerIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';

export default function ChangePlan() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [message, setMessage] = useState('');
    const isLoading = useSelector(selectRequestingChangePlan);

    const closeModal = () => dispatch(setChangePlanModal(false));

    const submit = () => {
        dispatch(requestChangePlanThunk({
            message,
            action: 'sales',
            email: profile?.email,
            subject: 'Change Plan',
            company: profile?.companyName,
            name: `${profile?.firstName} ${profile?.lastName}`,
        }));
    };

    return (
        <Modal
            size='sm'
            actions='both'
            restrictActionsWidth
            title='Upgrade plan'
            closeFunc={closeModal}
            icon={<LayerIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                onClick: submit,
                disabled: !message,
                loading: isLoading,
            }}
        >
            <div className={styles.contact_sales}>
                <p>{purchasePlanDialogue.ChangePlan}</p>
                <span>You can write your message here:</span>
                <TextArea label='Message' value={message} onChange={setMessage} />
            </div>
        </Modal>
    );
};
